/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'box': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.406 4.083l-9-4a.992.992 0 00-.812 0l-9 4A1 1 0 000 5v10a1 1 0 00.594.914l9 4a1 1 0 00.813 0l9-4A1 1 0 0020 15V5a1 1 0 00-.594-.917zM10 2.09L16.538 5l-1.788.8-6.538-2.906zm0 5.813L3.462 5 5.75 3.983l6.538 2.907zM2 6.536l7 3.112v7.813l-7-3.112V6.536zm9 10.925V9.648l7-3.112v7.813z" _fill="#474950" fill-rule="evenodd"/>'
  }
})
